import { PropsWithChildren, useEffect, useState } from 'react';

const HeightPreservingItem = ({ children, ...props }: PropsWithChildren ) => {
    const [size, setSize] = useState(0);

    //@ts-ignore
    const knownSize = props['data-known-size'];

    useEffect(() => {
        setSize((prevSize) => {
            return knownSize == 0 ? prevSize : knownSize;
        });
    }, [knownSize]);

    return (
        <div
            {...props}
            className="height-preserving-container"
            style={{
                //@ts-ignore
                '--child-height': `${size}px`
            }}
        >
            {children}
        </div>
    );
};

export { HeightPreservingItem };
